import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Navigation, Thumbs} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


function Gallery({data}) {
    const [arrayResources, SetArrayResources] = useState([]);
    useEffect(() => {
        if (data) {
            SetArrayResources(data);
        }
    }, [data]);

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (
        <>
            {
                arrayResources.length > 0 &&
                <div className="prod-gallery">
                    {/* Main Image */}
                    <div className="prod-gallery-main">
                        <Swiper
                            style={{
                                '--swiper-navigation-color': '#0049a8',
                                '--swiper-pagination-color': '#0049a8',
                            }}
                            loop={arrayResources.length > 1}
                            slidesPerView={1}
                            slidesPerGroup={1}
                            spaceBetween={10}
                            navigation={true}
                            thumbs={{swiper: thumbsSwiper}}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className="mySwiper rounded-xl overflow-hidden"
                        >
                            {
                                arrayResources.map((item, index) =>
                                    <SwiperSlide className="gallery-item" key={index}>
                                        <img src={item.url_resource} alt=""
                                             className="prod-gallery-img"/>
                                    </SwiperSlide>
                                )
                            }
                        </Swiper>
                    </div>

                    {/* Thumbnails */}
                    <div className="prod-gallery-thumbs-wrapper">
                        <Swiper
                            onSwiper={setThumbsSwiper}
                            loop={arrayResources.length > 1}
                            slidesPerGroup={1}
                            spaceBetween={8}
                            slidesPerView={4}
                            breakpoints={{
                                768: {
                                    slidesPerView: 5,
                                    spaceBetween: 10,
                                }
                            }}
                            freeMode={true}
                            watchSlidesProgress={true}
                            modules={[FreeMode, Navigation, Thumbs]}
                            className="prod-gallery-thumbs"
                        >
                            {
                                arrayResources.map((item, key) =>
                                    <SwiperSlide key={key} className="prod-thumb-slide">
                                        <div className="prod-thumb-container">
                                            <img className="prod-thumb-img"
                                                 src={item.url_resource} alt=""/>
                                        </div>
                                    </SwiperSlide>
                                )
                            }
                        </Swiper>
                    </div>
                </div>
            }

        </>
    );
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps, {})(Gallery)